import React from "react";

import PropTypes from "prop-types";

import FloatLabel from "./FloatingLabel";
import "./style.scss";

const Input = ({ placeholder, ...rest }) => {
  return (
    <FloatLabel
      className="container--input"
      label={placeholder}
      labelLeft={"label--left"}
      {...rest}>
      <textarea className={"text-area"} rows={2} {...rest} />
    </FloatLabel>
  );
};

Input.propTypes = {
  placeholder: PropTypes.string,
};
Input.defaultProps = {
  placeholder: "",
};
export default Input;
